import React, {useState} from 'react';
import UploadFilesForm from "./UploadFilesForm";

const UploadOrderFilesForm = ({
                                  label,
                                  year,
                                  orderId,
                                  change,
                                  setChange,
                                  fileNameType,
                                  uploadData,
                                  handleModalAlert
                              }) => {

    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleUpload = async (event) => {
        event.preventDefault();
        uploadData.upload && uploadData.upload(year, orderId, fileNameType, selectedFiles)
            .then(function () {
                setChange(!change)
                handleModalAlert("Данные загружены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(function () {
                event.target.reset();
                setSelectedFiles([])
            })
    }

    return (
        <div>
            <UploadFilesForm
                uploadData={uploadData}
                handleUpload={handleUpload}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                label={label}
            />
        </div>
    );
};

export default UploadOrderFilesForm;